import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { CareUserContext } from './provider/careUserContext';
import { manualStatusColours } from '../../../Components/helper';
import CustomTooltip from '../../../Components/Tooltip/CustomTooltip';

function ColumnDragTR({ colEle, colIndex }) {
  const { t } = useTranslation('common');
  const { setState } = useContext(CareUserContext);
  const handleEdit = () => {
    const valueExists = colEle?.columnDetails?.colourArray?.some((item) => item?.colourValue !== '');
    const editColumnDetails = {
      name: colEle?.name,
      columnType: colEle?.columnDetails?.columnType || null,
      isRequired: colEle?.columnDetails?.isRequired || false,
      options: colEle?.columnDetails?.options || [{ name: '' }],
      status: colEle?.columnDetails?.status || null,
      statusColoursOptions: colEle?.columnDetails?.statusColoursOptions || manualStatusColours,
      isStatusEditTrue: colEle?.columnDetails?.isStatusEditTrue || false,
      characterLimit: colEle?.columnDetails?.characterLimit || '',
      colorSwitch: colEle?.columnDetails?.colorSwitch || valueExists || false,
      colourArray: colEle?.columnDetails?.colourArray || [
        {
          colourValue: '',
          colourType: 'green',
          startPercentage: '',
          endPercentage: '',
        },
        {
          colourValue: '',
          colourType: 'amber',
          startPercentage: '',
          endPercentage: '',
        },
        {
          colourValue: '',
          colourType: 'red',
          startPercentage: '',
          endPercentage: '',
        },
      ],
    };
    setState((prevState) => ({
      ...prevState,
      showAddEditColumn: true,
      editMode: true,
      addColumns: [{ ...colEle, ...editColumnDetails }],
    }));
  };

  const handleColumnDelete = (id) => {
    setState((prevState) => ({
      ...prevState,
      showConfirmationPopup: true,
      deleteColumnId: id,
    }));
  };

  return (
    <tr key={colEle}>
      <td className="text-center">{colIndex + 1}</td>
      <td>{colEle?.name}</td>
      <td>{colEle?.columnDetails?.columnType?.type}</td>
      <td className="text-right">
        {!colEle?.isDefault && (
          <CustomTooltip tooltipText={t('CUSTOM_MODULE.EDIT_COLUMN')}>
            <button className="btn p-0" aria-label={t('CUSTOM_MODULE.EDIT_COLUMN')} onClick={handleEdit} type="button">
              <i className="icon-Edit-1 f-20 " />
            </button>
          </CustomTooltip>
        )}
        {!colEle?.isDefault && (
          <CustomTooltip tooltipText={t('CUSTOM_MODULE.DELETE_COLUMN')}>
            <button className="btn p-0" aria-label={t('CUSTOM_MODULE.DELETE_COLUMN')} onClick={() => handleColumnDelete(colEle._id)} type="button">
              <i className="icon-Delete f-20 ml-8" />
            </button>
          </CustomTooltip>
        )}
      </td>
    </tr>
  );
}

export default ColumnDragTR;
